import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    paddingVertical: 20,
    paddingHorizontal: 32,
    borderRadius: 7,
    borderWidth: 1,
    borderStyle: 'solid',
    flexDirection: 'row',
    gap: 8,
  },
  text: {
    fontSize: 16,
    fontWeight: 'bold',
  },
});
